<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  color: white;
  margin-top: 50px;
  text-align: center;
}

.slider{
  padding: 0 20px;
}
</style>

<div class="bg">
  <div class="title-signup">What proximity would you like for finding <u>events</u>?</div>
  
  <div class="margin slider">
    <RangeSlider id="distanceEvents" min="{2}" max="{80}" float bind:values="{distanceEvents}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
  </div>
  
  <div class="margin">Within {distanceEvents[0]} miles</div>
  
  
  <div class="title-signup">What proximity would you like for finding <u>friends</u>?</div>
  
  <div class="margin slider">
    <RangeSlider id="distanceFriends" min="{2}" max="{80}" float bind:values="{distanceFriends}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
  </div>
  
  <div class="margin">Within {distanceFriends[0]} miles</div>
  
  <div class="has-buttons"></div>
</div>

<div class="next">
  <button on:click="{next}">Next</button>
</div>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import RangeSlider from "svelte-range-slider-pips";

let distanceEvents = [2];
let distanceFriends = [2];


function next() {
  push("/signup/profile/personal/photos");
}


</script>